import React from 'react';

export interface NotificationAction {
  action: string;
  title: string;
}

export interface NotificationTestButtonProps {
  title: string;
  body?: string;
  actions?: NotificationAction[];
  icon?: string;
  buttonLabel?: string;
}

const NotificationTestButton: React.FC<NotificationTestButtonProps> = ({
  title,
  body = '',
  actions = [],
  icon,
  buttonLabel = 'Test Notification',
}) => {
  const handleClick = async () => {
    if (!('Notification' in window)) {
      alert('Notification API not supported.');
      return;
    }
    let permission = Notification.permission;
    if (permission !== 'granted') {
      permission = await Notification.requestPermission();
    }
    if (permission !== 'granted') {
      alert('Notification permission not granted.');
      return;
    }
    const options: NotificationOptions = {
      body,
      icon,
      // @ts-expect-error: actions is supported in modern browsers but not in TS lib.dom.d.ts yet
      actions,
    };
    // Prefer Service Worker if available
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.getRegistration().then(reg => {
        if (reg) {
          reg.showNotification(title, options);
        } else {
          new Notification(title, options);
        }
      });
    } else {
      new Notification(title, options);
    }
  };
  return (
    <button type="button" onClick={handleClick} style={{ padding: '6px 16px', borderRadius: 4, border: '1px solid #1976d2', background: '#1976d2', color: '#fff', cursor: 'pointer' }}>
      {buttonLabel}
    </button>
  );
};

export default NotificationTestButton; 